"use client";

import React from "react";
import Image from "next/image";

import { PortableText } from "@portabletext/react";
import { customRichTextComponent } from "@/sanity/sanityPortableText";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/shadcn/ui/accordion";

import { PageAdsSchema } from "@/sanity/pages/PageAdsTemplate";

import faqBG from "@/public/ads/faq-bg.png";

export default function FAQ({ data }: { data: PageAdsSchema }) {
  return (
    <section className="w-full pt-[6rem] lg:pt-0">
      <div className="max-w-[117rem] mx-auto px-[2rem] lg:px-0">
        <div className="flex flex-col items-center justify-end w-full mb-[2rem]">
          {data?.faqTitle && (
            <PortableText
              value={data?.faqTitle ?? []}
              components={customRichTextComponent({
                block: {
                  h2: ({ children }) => (
                    <h2 className="!text-white text-[4rem] lg:text-[5rem] font-[600] tracking-[-0.2rem] lg:tracking-[-0.28rem] leading-[100%] lg:leading-[120%] text-center mt-[2rem]">
                      {children}
                    </h2>
                  ),
                },
              })}
            />
          )}
        </div>

        <Accordion
          type="single"
          collapsible
          className="w-full"
          defaultValue="item-0"
        >
          {data?.faqItems?.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-black/30 mb-[2rem] p-[.5rem] border border-white/10 rounded-[2rem]"
            >
              <div className="faq-items border border-white/10 rounded-[2rem] px-[4rem] py-[1.5rem] lg:py-[2.5rem] relative overflow-clip [&_h3]:mb-0">
                <Image
                  className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                  alt="Background"
                  src={faqBG}
                />
                <AccordionTrigger className="text-white text-left text-[2.5rem] font-[400] leading-[3rem] opacity-85">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-white text-[2.25rem] font-[400] leading-[150%] opacity-60 pb-0 pt-2">
                  {faq.answer}
                </AccordionContent>
              </div>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
